import footerPreBuildDataBAK from "./preBuildedJsons/footerData.bak.json";
import rublockedFooterPreBuildDataBAK from "./preBuildedJsons/ruDisabledFooterData.bak.json";

export {
  footerPreBuildDataBAK as footerPreBuildData,
  rublockedFooterPreBuildDataBAK as footerRuBlockedPreBuildData,
};
